/**
 * 결제 금액 및 날짜 포맷팅 유틸리티
 * FSD: shared/lib/payment
 */

export const formatAmount = (amount: number | string): string => {
  const num = typeof amount === 'string' ? parseInt(amount, 10) : amount;
  return num.toLocaleString('ko-KR') + '원';
};

export const formatDate = (dateString: string): string => {
  try {
    return new Date(dateString).toLocaleDateString('ko-KR');
  } catch {
    return dateString;
  }
};

export const formatDateTime = (dateString: string): string => {
  try {
    return new Date(dateString).toLocaleString('ko-KR');
  } catch {
    return dateString;
  }
};
